import { actions } from "./Email.actions";

type Action = {
  type: keyof typeof actions;
  email?: string;
};

const initialState = {
  email: ""
};

export default function emailReducer(state = initialState, action: Action) {
  const { email } = state;
  switch (action.type) {
    case actions.SEND_EMAIL:
      return { email: action.email };
    case actions.EMAIL_CHANGE:
      return { email };
    case actions.EMAIL_RECOVERY:
      return initialState;
    default:
      return state;
  }
}
